
import Types from "./types";
import { CarService } from "../../../service/car-service";

const fetchDataSuccess = data => ({
    type: Types.FETCH_DATA_SUCCESS,
    data
});

const fetchDataFailure = error => ({
    type: Types.FETCH_DATA_FAILURE,
    error
});

const setIsLoading = flag => ({
    type: Types.SET_IS_LOADING,
    flag
});

const fetchData = (makeId) => dispatch => {
    dispatch(setIsLoading(true));
    return CarService.fetchModels(makeId)
        .then(response => {
            dispatch(fetchDataSuccess(response));
        })
        .catch(error => {
            dispatch(fetchDataFailure(error));
        });
};

const updateLeadModels = data => ({
    type: Types.UPDATE_POPULAR_MODELS,
    data
});

const fetchModelsBasedOnYearId = (makeId, yearId, queryParams = "") => dispatch => {
    dispatch(setIsLoading(true));
    return CarService.fetchModelsBasedOnYearAndMake(makeId, yearId, queryParams)
        .then(response => {
            dispatch(fetchDataSuccess(response));
        })
        .catch(error => {
            dispatch(fetchDataFailure(error));
        });
};

export {
    fetchData,
    updateLeadModels,
    fetchModelsBasedOnYearId
};
